import { render, staticRenderFns } from "./UserInvoices.vue?vue&type=template&id=456fe53c&"
import script from "./UserInvoices.vue?vue&type=script&lang=js&"
export * from "./UserInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports